import { Tooltip } from 'antd';
import { useTranslate } from '@tolgee/react';
import Icon from '@ant-design/icons';
import { ReactComponent as forwardSvgIcon } from 'views/Conversation/ConvList/assets/forward.svg';
import ForwardDlg from 'views/Conversation/ConvList/ForwardDlg';
import useModal from 'hooks/useModal';

interface ForwardProps {
  conversation: Conversation.Conversation;
}

export function Forward(props: ForwardProps) {
  const { conversation } = props;
  const { t } = useTranslate();
  const {
    visible: forwardModalVisible,
    meta: forwardModalMeta,
    show: showForwardModal,
    hide: hideForwardModal,
  } = useModal<Conversation.Conversation>();

  return (
    <>
      <Tooltip placement="top" title={t('ops.forward')}>
        <Icon
          component={forwardSvgIcon}
          onClick={() => {
            showForwardModal(conversation);
          }}
        />
      </Tooltip>
      {forwardModalVisible ? (
        <ForwardDlg conversation={forwardModalMeta} onClose={hideForwardModal} />
      ) : null}
    </>
  );
}
